import { httpClient } from "../../../api/httpClient";
import { urlGuardarCotizacionMotoPaso1, urlObtenerCotizacionMoto } from "../api/urls";
import { setMotosLoading, setMotosError, setDatosCotizacionPaso1, limpiarDatosCotizacion } from "./rMotos";

export { limpiarDatosCotizacion };

export const guardarCotizacionMotoPaso1 = (datos) => async (dispatch) => {
  dispatch(setMotosLoading(true));
  dispatch(setMotosError(null));
  try {
    const response = await httpClient.post(urlGuardarCotizacionMotoPaso1, datos);
    
    if (response && response.transaccion !== false) {
      var prodMoto = response.carrito && response.carrito.carProductos && response.carrito.carProductos[0];
      var datosVeh = response.datosVehiculo || (prodMoto && prodMoto.datosVehiculo) || datos.datosVehiculo;
      var textoDeclaracion = response.textoDeclaracionConductor || (response.carrito && response.carrito.textoDeclaracionConductor) || '';
      var cobsPdf = response.coberturasPdf || (prodMoto && prodMoto.coberturasPdf) || (response.carrito && response.carrito.coberturasPdf) || null;
      var esBloqueante = (response.esBloqueanteEmision !== undefined)
        ? Boolean(response.esBloqueanteEmision)
        : (response.plan && response.plan.esBloqueanteEmision !== undefined)
          ? Boolean(response.plan.esBloqueanteEmision)
          : (prodMoto && prodMoto.esBloqueanteEmision !== undefined)
            ? Boolean(prodMoto.esBloqueanteEmision)
            : (response.carrito && response.carrito.esBloqueanteEmision !== undefined)
              ? Boolean(response.carrito.esBloqueanteEmision)
              : (response.cotizacion && response.cotizacion.esBloqueanteEmision !== undefined)
                ? Boolean(response.cotizacion.esBloqueanteEmision)
                : false;
      var txtBloqueo = response.txtBloqueoEmision || 
        (response.plan && response.plan.txtBloqueoEmision) || 
        (prodMoto && prodMoto.txtBloqueoEmision) || 
        (response.carrito && response.carrito.txtBloqueoEmision) || 
        (response.cotizacion && response.cotizacion.txtBloqueoEmision) || '';

      dispatch(setDatosCotizacionPaso1({
        idCarrito: response.idCarrito,
        idCotizacion: response.idCotizacion,
        plan: response.plan,
        cotizacion: response.cotizacion,
        coberturas: response.coberturas,
        coberturasPdf: cobsPdf,
        valorTotal: response.valorTotal,
        carrito: response.carrito,
        datosVehiculo: datosVeh,
        datosAsegurado: response.datosAsegurado || (response.carrito && response.carrito.datosAsegurado) || datos.datosAsegurado,
        datosConductor: response.datosConductor || (response.carrito && response.carrito.datosConductor) || datos.datosConductor,
        textoDeclaracionConductor: textoDeclaracion,
        esBloqueanteEmision: esBloqueante,
        txtBloqueoEmision: txtBloqueo
      }));
      return { exito: true, data: response };
    } else {
      const errorMsg = response.errorDescripcion || "Ocurrió un error al guardar los datos del vehículo.";
      dispatch(setMotosError(errorMsg));
      return { exito: false, error: errorMsg };
    }
  } catch (error) {
    dispatch(setMotosError("Excepción al comunicarse con el servidor: " + error.message));
    return { exito: false, error: error.message };
  } finally {
    dispatch(setMotosLoading(false));
  }
};

export const obtenerCotizacionMoto = (idCarrito) => async (dispatch) => {
  dispatch(setMotosLoading(true));
  dispatch(setMotosError(null));
  try {
    const response = await httpClient.get(`${urlObtenerCotizacionMoto}&idCarrito=${idCarrito}`);
    
    if (response && response.transaccion !== false) {
      var prodMoto = response.carrito && response.carrito.carProductos && response.carrito.carProductos[0];
      var textoDeclaracion = response.textoDeclaracionConductor || (response.carrito && response.carrito.textoDeclaracionConductor) || '';
      var cobsPdf = response.coberturasPdf || (prodMoto && prodMoto.coberturasPdf) || (response.carrito && response.carrito.coberturasPdf) || null;
      var esBloqueante = (response.esBloqueanteEmision !== undefined)
        ? Boolean(response.esBloqueanteEmision)
        : (response.plan && response.plan.esBloqueanteEmision !== undefined)
          ? Boolean(response.plan.esBloqueanteEmision)
          : (prodMoto && prodMoto.esBloqueanteEmision !== undefined)
            ? Boolean(prodMoto.esBloqueanteEmision)
            : (response.carrito && response.carrito.esBloqueanteEmision !== undefined)
              ? Boolean(response.carrito.esBloqueanteEmision)
              : (response.cotizacion && response.cotizacion.esBloqueanteEmision !== undefined)
                ? Boolean(response.cotizacion.esBloqueanteEmision)
                : false;
      var txtBloqueo = response.txtBloqueoEmision || 
        (response.plan && response.plan.txtBloqueoEmision) || 
        (prodMoto && prodMoto.txtBloqueoEmision) || 
        (response.carrito && response.carrito.txtBloqueoEmision) || 
        (response.cotizacion && response.cotizacion.txtBloqueoEmision) || '';

      dispatch(setDatosCotizacionPaso1({
        idCarrito: response.idCarrito,
        idCotizacion: response.idCotizacion,
        plan: response.plan,
        cotizacion: response.cotizacion,
        coberturas: response.coberturas,
        coberturasPdf: cobsPdf,
        valorTotal: response.valorTotal,
        carrito: response.carrito,
        datosVehiculo: response.datosVehiculo,
        datosAsegurado: response.datosAsegurado || (response.carrito && response.carrito.datosAsegurado),
        datosConductor: response.datosConductor || (response.carrito && response.carrito.datosConductor),
        textoDeclaracionConductor: textoDeclaracion,
        esBloqueanteEmision: esBloqueante,
        txtBloqueoEmision: txtBloqueo
      }));
      return { exito: true, data: response };
    } else {
      const errorMsg = response.errorDescripcion || "No se pudo obtener la cotización.";
      dispatch(setMotosError(errorMsg));
      return { exito: false, error: errorMsg };
    }
  } catch (error) {
    dispatch(setMotosError("Excepción al comunicarse con el servidor: " + error.message));
    return { exito: false, error: error.message };
  } finally {
    dispatch(setMotosLoading(false));
  }
};
